import styled from '@emotion/styled';

/** List of buttons that are arranged in inline and break to the next line if necessary.  */
export const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--form-gutter);
`;
